import React from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import {BaasicFormControls, BaasicButton, EditFormContent} from 'core/components';
import {Page, PageFooter} from 'core/layouts';
import {defaultTemplate} from 'core/hoc';
import {getPageObject} from 'core/utils';

function EditFormLayoutTemplate({ store, children, t, layoutFooterVisible, loading, disabled, hasSubmitPermission = true }) {
    const {
        rootStore,
        form,
        loaderStore
    } = store;
    const { header, footer, content } = getPageObject(children);
    return (
        <Page loading={!_.isNil(loading) ? loading : loaderStore.loading} >
            {header}
            {content.header}
            {content.sidebar}
            <EditFormContent form={form}>
                    {content.children}
            </EditFormContent>
            {content.footer}
            {renderEditLayoutFooterContent({
                footer,
                form,
                visible: layoutFooterVisible,
                t,
                goBack: () => rootStore.routerStore.goBack(),
                disabled,
                hasSubmitPermission
            })}
        </Page>
    );
}

function renderEditLayoutFooterContent({ footer, form, visible, goBack, t, disabled, hasSubmitPermission }) {
    return visible ? (
        footer
            ? footer
            : (
                <PageFooter>
                    <BaasicFormControls form={form} onSubmit={form.onSubmit} disabled={disabled} authorized={hasSubmitPermission}/>
                    <BaasicButton
                        className='btn btn--base btn--ghost'
                        label={t('EDIT_FORM_LAYOUT.CANCEL')}
                        onClick={goBack}
                    />
                </PageFooter>
            )
    ) : null
}

EditFormLayoutTemplate.propTypes = {
    store: PropTypes.object,
    loading: PropTypes.bool,
    layoutFooterVisible: PropTypes.bool,
    children: PropTypes.any,
    t: PropTypes.func,
    disabled:PropTypes.bool,
    hasSubmitPermission: PropTypes.any
};

EditFormLayoutTemplate.defaultProps = {
    layoutFooterVisible: true
};

export default defaultTemplate(EditFormLayoutTemplate);
